import styled from 'styled-components'

import { Card } from '@/components/ui/card'

export const ContentCard = styled(Card)`
  height: auto;
  overflow: visible;
`
